import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./About.css";

const OurTech: React.FC = () => {
  return (
    <Container className="about-page py-5">
      <Row className="mb-0">
        <Col md={12}>
          <h2 className="text-center mb-4">Our Technology</h2>
          <p className="text-center mb-5">
            Fyled AI leverages advanced machine learning models and computer
            vision to transform how scientists work with chemical structures.
          </p>

          <Row>
            <Col md={4} className="mb-4">
              <Card className="h-100 shadow-sm">
                <Card.Body className="p-4">
                  <h3 className="h5 mb-3">AI-Powered Recognition</h3>
                  <p>
                    Our proprietary algorithms can accurately identify and
                    digitize chemical structures from images and PDFs with
                    exceptional accuracy.
                  </p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4} className="mb-4">
              <Card className="h-100 shadow-sm">
                <Card.Body className="p-4">
                  <h3 className="h5 mb-3">Molecular Visualization</h3>
                  <p>
                    Interactive 3D visualization tools help researchers better
                    understand molecular structures and their properties.
                  </p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4} className="mb-4">
              <Card className="h-100 shadow-sm">
                <Card.Body className="p-4">
                  <h3 className="h5 mb-3">Data Integration</h3>
                  <p>
                    Seamlessly connect with chemical databases and research
                    tools to enhance your existing workflow.
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default OurTech;
